import { render, staticRenderFns } from "./etiquetas.vue?vue&type=template&id=6a2ce5ea&scoped=true"
import script from "./etiquetas.vue?vue&type=script&lang=js"
export * from "./etiquetas.vue?vue&type=script&lang=js"
import style0 from "./etiquetas.vue?vue&type=style&index=0&id=6a2ce5ea&prod&lang=css"
import style1 from "./etiquetas.vue?vue&type=style&index=1&id=6a2ce5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ce5ea",
  null
  
)

export default component.exports